import { useCallback } from "react";
import { authAxios } from "../axios";

export const usePasswordSearchAndLogin = () => {
  const [state, execute, cancel] = authAxios<void, { email: string; password: string }, unknown>({
    url: "/password/searchAndLogin",
    method: "POST",
  });

  const callback = useCallback(
    (email: string, password: string) => {
      return execute({
        data: {
          email,
          password,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
